var pageNum = null;
var lastPosted = "";
var conTypeWL = {
    'News':['Article','Video','VictoryReport'],
    'Article': ['Article'],
    'Petition':['Petition'],
    'Topic': ['Article', 'Petition','VictoryReport'],
    'Tag': ['Article', 'Petition', 'Video'],
    'VictoryReport':['VictoryReport'],
    'Videos':['Video'],
    'RadioList':['RadioShow']
}
var templateMap = {
    'Article': 'featuredArticleWidget',
    'Petition': 'featuredArticleWidget',
    'VictoryReport':'featuredArticleWidget',
    'Video': 'featuredVideoWidget',
    'RadioShow': 'radioListWidget'
}

function getMoreContent(options){
    if(typeof options.$contentContainer !== 'undefined') var $contentContainer = options.$contentContainer;
    else var $contentContainer = $('#latestContent .container');
    if(typeof options.pageType == 'string' && typeof conTypeWL[options.pageType] !== 'undefined')
        var pageType = options.pageType;
    else
        var pageType = 'News';
    var pageSize = options.pageSize || 10;
    var pageSizeCheck = options.pageSizeCheck || pageSize;
    var localMap = JSON.parse(JSON.stringify(templateMap));
    if(pageType == 'Topic' || pageType == 'Tag' || pageType == 'Article'){
        localMap['Article'] = 'articleWidget';
        localMap['Petition'] = 'petitionWidget';
        localMap['Video'] = 'videoSidebarWidget';
        localMap['VictoryReport'] = 'articleWidget';
    }
    var altSkip = (typeof options.altSkip == 'boolean')? options.altSkip : false;
    var url = (typeof options.url == 'string' && options.url !== '')? options.url : "/getmore";
    var contentTypes = conTypeWL[pageType];
    var categories = (pageType == 'Videos')? genCategoryList() : [];
    var tags = options.tags || [];
    if(typeof options.topics == 'object' && options.topics.length)
        var topics = options.topics;
    else
        var topics = (pageType == 'RadioList')? genTopicList() : [];
    if(typeof options.lastItem !== 'undefined' && lastPosted == "")
        lastPosted = options.lastItem;
    if(typeof options.itemWrapper == 'string' && options.itemWrapper.match(/CONTENT\_HERE/))
        var itemWrapper = options.itemWrapper;
    if(pageNum == null) pageNum = queryString.getQueryVariable('page') || 1;
    if(typeof options.pageNum !== 'undefined') pageNum = options.pageNum;
    if(options.append)
        pageNum++;
    else{
        pageNum = 1;
        $contentContainer.empty();
        lastPosted = "";
    }
    var author = (typeof options.author == 'string' && options.author !== '')? options.author : "";
    var hideVerticalDotsOn = options.hideVerticalDotsOn || null;
    if(typeof options.data == 'object' && typeof options.data.length == 'undefined')
        var data = options.data;
    else
        var data = {};
    data.contentTypes = contentTypes;
    data.pageSize = pageSize;
    data.pageNum = pageNum;
    data.categories = categories;
    data.tags = tags;
    data.author = author;
    data.topics = topics;
    data.altSkip = altSkip;
    data.html = {
        lastPosted: lastPosted,
        template: localMap,
        model: (typeof options.model == 'object')? options.model : {}
    }
    $.ajax({
        url: url,
        data: data,
        success: function(data){
            if(data.Content.length > 0){
                var rowCount = 0;
                if(pageType === "Article"){
                    var newRowContent = document.createElement('div')
                    newRowContent.setAttribute('class', 'row')
                    $(newRowContent).css({"margin-top": "20px", "height": "475px"})
                }
                for(var i = 0; i < data.Content.length; i++){
                    if(itemWrapper)
                        data.Content[i] = itemWrapper.replace(/CONTENT\_HERE/, data.Content[i]);
                    if(pageType === "Article" && author.length < 1)
                        var $newElement = $(data.Content[i]).appendTo(newRowContent);
                    else
                        var $newElement = $(data.Content[i]).appendTo($contentContainer);
                    
                    if(hideVerticalDotsOn !== null){
                        rowCount++;
                        if(rowCount == hideVerticalDotsOn){
                            ($newElement.find('.vertical-dots')).hide();
                            rowCount = 0;
                        }
                    }
                    processVimeoImg.apply($newElement.find('.featuredContent.featuredVideo .autoLoadVideo img'));
                    processTimestamp($newElement.find('.timestamp'));
                    if(pageType === "Article" && author.length < 1)
                        $(newRowContent).appendTo($contentContainer)
                }
            }
            try{
                lastPosted = $('#latestContent .row a.readMore').last().attr('href').replace(/^\//,'');
            }catch(e){};
            if(data.Content.length < pageSizeCheck) {
				$('.readMoreContainer').parent().hide();
			} else {
				$('.readMoreContainer').parent().show();
			}
        },
        dataType: 'json'
    })
}

function loadMoreTopics(topicCount,topicPageNum,contentTypes){ //Loads more topics into topics selector filter
  var url = '/getmoretopics';
  $.ajax({
    url: url,
    data: {
      contentTypes: contentTypes,
      topicCount: topicCount,
      pageNum: topicPageNum
    },
    success: function(data){
      if(data.Content.length > 0){
        for(var i = 0; i < data.Content.length; i++){
          $('form.form-inline').append(data.Content[i]);
        }
      }
      if(data.Content.length < topicCount) {
        $('.loadMoreTopics').hide();
        $('#radioShows').css("margin-bottom", "30px")
      } else {
        $('.loadMoreTopics').show();
      }
    },
    dataType: "json"
  });
}

function genCategoryList(){
    var categories = [];
    $('.categoryCheckbox').each(function(){
        if($(this).is(':checked')){
            categories.push($(this).attr('name'));
        }
    });
    return categories;
}

function genTopicList(){
    var topics = [];
    $('.topicCheckbox').each(function(){
		if($(this).is(':checked')){
			topics.push($(this).attr('name'));
		}
	});
    return topics;
}